import { useState, useCallback, RefObject, useEffect } from 'react';

export function useWidth<T extends Element>(elementRef: RefObject<T>) {
  const [width, setWidth] = useState<number>();

  const updateWidth = useCallback(() => {
    if (elementRef && elementRef.current) {
      const { width } = elementRef.current.getBoundingClientRect();
      setWidth(width);
    }
  }, [elementRef]);

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, [updateWidth]);

  return width;
}
